import { CrossIcon } from '../../Icons';
import { badgeVariants, closeButtonVariants } from '../logic';

type BaseProps = {
  /** ステータス */
  status: 'neutral' | 'info' | 'success' | 'warning' | 'negative';
  /** バリエーション */
  variant: 'outline' | 'solid' | 'subtle';
  /** ラベルのテキスト */
  label: string;
};

// size: 'sm' の場合はcloseボタンを表示しない
type SmallBadgeProps = BaseProps & {
  size: 'sm';
  showClose?: never;
  onClickClose?: never;
};

// showClose: falseの場合はonClickCloseを渡せない
type MediumLargeBadgeProps = BaseProps & {
  size: 'md' | 'lg';
} & ({ showClose: true; onClickClose: () => void } | { showClose: false; onClickClose?: never });

type Props = SmallBadgeProps | MediumLargeBadgeProps;

export const BadgePresentation: React.FC<Props> = ({
  status,
  variant,
  label,
  size,
  showClose,
  onClickClose,
  ...props
}) => {
  const badgeClasses = badgeVariants({ status, variant, size });
  const buttonClasses = closeButtonVariants({ status, variant, size });
  return (
    <span className={badgeClasses} {...props}>
      {label}
      {size !== 'sm' && showClose && (
        <button className={buttonClasses} onClick={onClickClose} type='button'>
          <CrossIcon size='xs' />
        </button>
      )}
    </span>
  );
};
